import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Holda Maurice </span>
            from <span className="purple"> Hamburg, Germany.</span>
            <br />I am a junior WebDev Student @ DCI - School
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Organize Music Events
            </li>
            <li className="about-activity">
              <ImPointRight /> Producing Beats
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Maurice</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
